import Promise from 'promise-polyfill';
import { error as logError } from '../shared/logger';
import StatusError from './status-error';

const getEvalVersion = require('../app/utils/get-eval-version');
// Integration Tests Helper: Uncomment these lines and the calls to mockGenerator to easily generate mocks for new/updated integration tests
// function mockGenerator(url, method, body, response, status) {
// 	window.evalMocks = window.evalMocks || [];
// 	window.evalMocks.push({ url, method, body, response, status });
// 	console.log('EVAL MOCKS', JSON.stringify(window.evalMocks));
// }

function request({ url, headers, body, method = 'GET', withCredentials = true, accept }) {
	const evalVersion = getEvalVersion();
	// eslint-disable-next-line no-param-reassign
	url = url?.includes('?') ? `${url}&evalV=${evalVersion}` : `${url}?evalV=${evalVersion}`;

	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.onload = () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				try {
					const response = accept === 'json' && xhr.responseText ? JSON.parse(xhr.responseText) : xhr.responseText;
					resolve({ success: true, body: response, httpStatus: xhr.status });
					// mockGenerator(url, method, body, response, xhr.status);
				} catch (err) {
					err.message += ` (URL: ${url})`;
					logError(err);
					reject(err);
				}
			} else {
				// mockGenerator(url, method, body, accept === 'json' && xhr.responseText ? JSON.parse(xhr.responseText) : xhr.responseText, xhr.status);
				reject(new StatusError(xhr.status, `Request failed: ${url}`));
			}
		};
		xhr.onerror = () => {
			// mockGenerator(url, method, body, accept === 'json' && xhr.responseText ? JSON.parse(xhr.responseText) : xhr.responseText, xhr.status);
			reject(new StatusError(500, `Request failed: ${url}`));
		};
		xhr.open(method, url, true);
		xhr.withCredentials = withCredentials;

		// Notes: csrf-token is needed to support onboarding flow from authz handlers
		if (url.includes('api')) {
			if (window.ancestry?.csrfToken) {
				xhr.setRequestHeader('X-CSRF-Token', window.ancestry.csrfToken);
			}
		}

		if (headers) {
			Object.keys(headers).forEach(key => {
				xhr.setRequestHeader(key, headers[key]);
			});
		}
		if (body) {
			xhr.send(JSON.stringify(body));
		} else {
			xhr.send();
		}
	});
}

export default request;
